import { render } from "./WaitingComponent.vue?vue&type=template&id=0f2c0483"
import script from "./WaitingComponent.vue?vue&type=script&lang=js"
export * from "./WaitingComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sweaton/WebstormProjects/paygateway/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__